module.exports = __webpack_public_path__ + "img/banner tijdelijk aanbod1.0d89d11b.png";